/* eslint-disable no-unused-vars */
// import axios from 'axios'
import axios from '../../helpers/Axios'

export const quicksearchmodule = {

	namespaced: true,

	state: {
		results: [],
		resultCount: 0,
		searchTerm: '',
		searchPostcodeTerm: '',
		take: 50,
		skip: 0,
		searchType: '',
		selectAllData: {}
	},
	getters: {
		results: state => {
			return state.results;
		}
	},
	actions: {
		doQuickSearch({ commit, state }, payload) {

			const config = { headers: { 'Content-Type': 'application/json', 'Cache-Control': 'no-cache', Pragma: 'no-cache' } };

			if (state.searchType === 'name') {

				return axios.post('/quicksearch/search?searchTerm=' + encodeURIComponent(payload.searchTerm) + '&take=' + encodeURIComponent(payload.take) + '&skip=' + encodeURIComponent(payload.skip), config).then(response => {
					commit('updateResults', response.data);
				}).catch(err => {
					console.log(err);
				});
			} else {
				return axios.post('/quicksearch/postcode?searchTerm=' + encodeURIComponent(payload.searchTerm) + '&take=' + encodeURIComponent(payload.take) + '&skip=' + encodeURIComponent(payload.skip), config).then(response => {
					commit('updateResults', response.data);
				}).catch(err => {
					console.log(err);
				});
			}
		},
		chooseAllCompanies({ commit, state }, payload) {

			if (state.searchType === 'name') {
				state.selectAllData.searchTerm = state.searchTerm;
				return axios.post('/quicksearch/choose-all', state.selectAllData).then(response => {
					let companySearchId = response.data;
					global.location = '/results/' + companySearchId;
				}).catch(err => {
					console.log(err);
				});
			} else {
				state.selectAllData.searchTerm = state.searchPostcodeTerm;
				return axios.post('/quicksearch/choose-all-postcode', state.selectAllData).then(response => {
					let companySearchId = response.data;
					global.location = '/results/' + companySearchId;
				}).catch(err => {
					console.log(err);
				});
			}
		}
	},
	mutations: {
		updateResults(state, data) {
			state.results = data.results;
			state.resultCount = data.resultCount;
		},
		updateSearchTerm(state, searchTerm) {
			state.searchTerm = searchTerm;
		},
		updateSearchPostcodeTerm(state, searchTerm) {
			state.searchPostcodeTerm = searchTerm;
		},
		updateTake(state, take) {
			state.take = take;
		},
		updateSkip(state, skip) {
			state.skip = skip;
		},
		updateSearchType(state, type) {
			state.searchType = type;
		}
	}

}
